import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { QuestionFull } from '@fabric-ui/icons';
import { iconSize } from '@fabric-ui/utils';
import { Box } from '@mui/material';

export const BREAKDOWN_UNAVAILABLE_TOOLTIP = 'This breakdown isn’t available for the selected date range.';

export const HISTORICAL_BREAKDOWN_GUIDANCE = [
  { range: '< 90 days', options: 'Days / Weeks / Months' },
  { range: '90–179 days', options: 'Weeks / Months' },
  { range: '≥ 180 days', options: 'Months' },
] as const;

const BreakdownTooltipContent = () => (
  <Box className="flex flex-col gap-2">
    <Box className="text-xs text-content-base-primary">Available breakdowns depend on the selected date range.</Box>
    <Box className="flex flex-col">
      {HISTORICAL_BREAKDOWN_GUIDANCE.map(({ range, options }) => (
        <Box key={range} className="flex items-center gap-4 border-b border-border-base-primary pb-2.5 pt-2.5 last:border-b-0 last:pb-0">
          <Box className="w-24 whitespace-nowrap text-xs font-medium text-content-base-primary">{range}</Box>
          <Box className="flex-1 whitespace-nowrap text-xs text-content-base-primary">{options}</Box>
        </Box>
      ))}
    </Box>
  </Box>
);

export const BreakdownGuidanceTooltip = ({
  placement = 'right',
  width = 295,
}: {
  placement?: 'right' | 'top' | 'bottom' | 'left';
  width?: number;
}) => (
  <AvTooltip
    color="white"
    title={<BreakdownTooltipContent />}
    variant="message"
    muiProps={{
      placement,
      PopperProps: {
        onClick: e => e.stopPropagation(),
        sx: { '.MuiTooltip-tooltip': { width: `${width}px`, padding: '16px' } },
      },
    }}>
    <Box className="cursor-pointer">
      <QuestionFull {...iconSize(16)} />
    </Box>
  </AvTooltip>
);

export const BreakdownUnavailableTooltip = ({
  children,
  ...props
}: {
  children: React.ReactElement;
} & Omit<React.ComponentProps<typeof AvTooltip>, 'title' | 'children'>) => (
  <AvTooltip title={BREAKDOWN_UNAVAILABLE_TOOLTIP} {...props}>
    {children}
  </AvTooltip>
);

export default BreakdownTooltipContent;
